'use client';
// typescript will throw an error if a new style key is added and it's not configured here
// we could probably be smarter about this by converting the style key name to kebab case
const styleKeyVarMap = {
    core: '',
    utility: '',
    accordion: '--swan-accordion',
    alertBox: '--swan-alert-box',
    anchorBar: '--swan-anchor-bar',
    avatar: '--swan-avatar',
    banner: '--swan-banner',
    button: '--swan-button',
    carousel: '--swan-carousel',
    /** @deprecated. This is no longer needed, as the styling is already present in the core stylesheet, so just remove it's usage */ fieldSet: '--swan-fieldset',
    grid: '--swan-grid',
    hidden: '--swan-hidden',
    icon: '--swan-icon',
    listbox: '--swan-listbox',
    modalDialog: '--swan-modal-dialog',
    pagination: '--swan-pagination',
    popover: '--swan-popover',
    priceBar: '--swan-price-bar',
    /** @deprecated. This is no longer needed, as the styling is already present in the core stylesheet, so just remove it's usage */ pricing: '--swan-pricing',
    progressBar: '--swan-progress-bar',
    progressiveImage: '',
    ratingsStars: '--swan-ratings-stars',
    selectionSet: '--swan-selection-set',
    spinner: '--swan-spinner',
    standardTile: '--swan-standard-tile',
    stepIndicator: '--swan-step-indicator',
    table: '--swan-table',
    tabs: '--swan-tabs',
    thumbnailsHero: '--swan-thumbnails-hero',
    toggleSwitch: '--swan-toggle-switch',
    visible: '--swan-visible',
    zoomControls: '--swan-zoom-controls'
};

export { styleKeyVarMap };
